import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      label: '客户分类',
      field: 'custType',
      type: 'select',
      placeholder: '请选择客户分类',
      clearable: true,
      options: [
        {title: 'A类', value: '0'},
        {title: 'B类', value: '1'},
        {title: 'C类', value: '2'},
        {title: 'D类', value: '3'}
      ]
    },
    {
      label: '客户昵称',
      field: 'custName',
      type: 'input',
      placeholder: '请输入客户昵称/名字'
    },
    {
      label: '开发账号',
      field: 'exploitAccount',
      type: 'input',
      placeholder: '请输入开发账号'
    }
  ]
}
